import { render } from "./BaseTable2.vue?vue&type=template&id=3347f7f2&scoped=true"
import script from "./BaseTable2.vue?vue&type=script&lang=js"
export * from "./BaseTable2.vue?vue&type=script&lang=js"

import "./BaseTable2.vue?vue&type=style&index=0&id=3347f7f2&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3347f7f2"]])

export default __exports__